import { render } from "./WorkOrderForm.vue?vue&type=template&id=637a6ce3"
import script from "./WorkOrderForm.vue?vue&type=script&lang=js"
export * from "./WorkOrderForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__